import { render, staticRenderFns } from "./error.vue?vue&type=template&id=116369e4&scoped=true&"
import script from "./errorControl.js?vue&type=script&lang=js&"
export * from "./errorControl.js?vue&type=script&lang=js&"
import style0 from "./error.css?vue&type=style&index=0&id=116369e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116369e4",
  null
  
)

export default component.exports